(() => {
  const root = document.querySelector('[data-search-page]');
  if (!root) return;

  const terms = (root.getAttribute('data-search-terms') || '').trim();
  const grid = root.querySelector('[data-search-grid]');
  const empty = root.querySelector('[data-search-empty]');
  const countEl = root.querySelector('[data-search-count]');
  const moneyFormat = root.getAttribute('data-money-format') || '';
  const predictiveSearchUrl = root.getAttribute('data-predictive-search-url') || '/search/suggest';

  if (!terms || !grid || grid.children.length) return;

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const formatMoney = (price) => {
    const cents = Math.round(Number.parseFloat(price || 0) * 100);
    const noDecimalFormat = moneyFormat
      .replace('amount_with_comma_separator', 'amount_no_decimals_with_comma_separator')
      .replace('amount_with_space_separator', 'amount_no_decimals_with_space_separator')
      .replace('{{amount}}', '{{amount_no_decimals}}')
      .replace('{{ amount }}', '{{amount_no_decimals}}');

    if (window.Shopify?.formatMoney && noDecimalFormat) {
      return window.Shopify.formatMoney(cents, noDecimalFormat);
    }

    const whole = Math.round(cents / 100).toString();
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (moneyFormat) return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/g, grouped);
    return grouped;
  };

  const getProductImage = (product) => {
    const featured = product?.featured_image;
    const imageUrl =
      (typeof featured === 'string' ? featured : featured?.url) ||
      product?.image ||
      product?.featured_image?.src ||
      '';
    if (!imageUrl) return '';
    const normalized = imageUrl.startsWith('//') ? `https:${imageUrl}` : imageUrl;
    return normalized.includes('?') ? `${normalized}&width=700` : `${normalized}?width=700`;
  };

  const suggestUrl = new URL(predictiveSearchUrl, window.location.origin);
  if (!suggestUrl.pathname.endsWith('.json')) {
    suggestUrl.pathname = `${suggestUrl.pathname}.json`;
  }
  suggestUrl.searchParams.set('q', terms);
  suggestUrl.searchParams.set('resources[type]', 'product');
  suggestUrl.searchParams.set('resources[limit]', '10');
  suggestUrl.searchParams.set('resources[options][unavailable_products]', 'last');

  fetch(suggestUrl.toString(), { headers: { Accept: 'application/json' } })
    .then((response) => {
      if (!response.ok) throw new Error('Search fallback failed');
      return response.json();
    })
    .then((data) => {
      const products = data?.resources?.results?.products || [];
      if (!products.length) return;

      grid.innerHTML = products
        .map((product) => {
          const title = escapeHtml(product.title);
          const url = escapeHtml(product.url);
          const image = getProductImage(product);
          const price = escapeHtml(formatMoney(product.price));
          return `
            <div class="search-page__item">
              <article class="product-card product-card--align-center" style="--product-card-media-ratio: 2.4 / 3.9;">
                <div class="product-card__media-wrap">
                  <a class="product-card__media" href="${url}" aria-label="${title}">
                    ${image ? `<img class="product-card__image product-card__image--primary" src="${escapeHtml(image)}" alt="${title}" loading="lazy" width="700" height="900">` : ''}
                  </a>
                </div>
                <div class="product-card__content">
                  <p class="product-card__title h2"><a href="${url}">${title}</a></p>
                  <div class="product-card__price"><span>${price}</span></div>
                </div>
              </article>
            </div>
          `;
        })
        .join('');

      if (empty) empty.hidden = true;
      if (countEl) {
        countEl.hidden = false;
        const showingTemplate =
          window.SculptStrings?.searchShowing || 'Showing {{ from }}–{{ to }} of {{ count }} results';
        countEl.textContent = showingTemplate
          .replace(/\{\{\s*from\s*\}\}/g, '1')
          .replace(/\{\{\s*to\s*\}\}/g, String(products.length))
          .replace(/\{\{\s*count\s*\}\}/g, String(products.length));
        countEl.closest('.search-page__pagination')?.removeAttribute('hidden');
      }
    })
    .catch((error) => console.error(error));
})();
